import React from "react";
import api from "../utils/axios";
import { Button } from "@chakra-ui/react";
import { CSVLink } from "react-csv";
import { hasPermission } from "../utils/helpers";

export default class DownloadUsersCSVButton extends React.Component {
  static stringifyObjectFields = (obj) => {
    const newObj = { ...obj };
    Object.entries(newObj).forEach(([key, value]) => {
      if (typeof value === "object") {
        newObj[key] = JSON.stringify(value).replace(/,/g, " ");
      }
    });

    return newObj;
  };

  static convertToSingleDepth = (value) => {
    if (value == null) {
      return null;
    }

    if (typeof value === "object") {
      const newObj = { ...value };
      Object.entries(value).forEach(([objKey, objVal]) => {
        const destructuredObj = this.convertToSingleDepth(objVal);

        if (destructuredObj != null && typeof destructuredObj === "object") {
          Object.entries(destructuredObj).forEach(
            ([innerObjKey, innerObjVal]) => {
              const newKey = `${objKey}_${innerObjKey}`;
              newObj[newKey] = innerObjVal;
            }
          );
          delete newObj[objKey];
        }
      });

      return newObj;
    }

    return value;
  };

  csvLink = React.createRef();
  csvHeaders = [
    { label: "Family ID", key: "familyId" },
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Chinese Name", key: "chineseName" },
    { label: "Gender", key: "gender" },
    { label: "Age", key: "age" },
    { label: "Grade", key: "grade" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "homePhoneNumber" },
    { label: "Cell Phone", key: "cellPhoneNumber" },
    { label: "Street No.", key: "address_streetNo"},
    { label: "Street Name", key: "address_streetName"},
    { label: "City", key: "address_city"},
    { label: "State", key: "address_state"},
    { label: "State", key: "address_zipCode"},
    { label: "State", key: "address_country"},
    { label: "Preferred Language", key: "preferredLanguage" },
    { label: "Parent/Guardian Phone", key: "emergencyPhoneNumber" },
    { label: "Parent/Guardian Email", key: "parentGuardianEmail" },
    { label: "Church", key: "church_long_name" },
    { label: "Group", key: "group_name" },
    { label: "Room Number", key: "dorm_room_number" },
    { label: "Room Name", key: "dorm_name" },
    { label: "Dorm Building", key: "dorm_building_name" },
    { label: "Specail Needs", key: "specialNeeds" },
    { label: "Resident Status", key: "resident_commuter_status" },
    { label: "Lodging Day 1", key: "lodging_0_date" },
    { label: "Lodging", key: "lodging_0_name" },
    { label: "Lodging Day 2", key: "lodging_1_date" },
    { label: "Lodging", key: "lodging_1_name" },
    { label: "Lodging Day 3", key: "lodging_2_date" },
    { label: "Lodging", key: "lodging_2_name" },
    { label: "Meal Day 1", key: "meals_0_date" },
    { label: "Meal Name", key: "meals_0_name" },
    { label: "Meal Day 2", key: "meals_1_date" },
    { label: "Meal Name", key: "meals_1_name" },
    { label: "Meal Name", key: "meals_2_name" },
    { label: "Meal Name", key: "meals_3_name" },
    { label: "Meal Day 3", key: "meals_4_date" },
    { label: "Meal Name", key: "meals_4_name" },
    { label: "Meal Name", key: "meals_5_name" },
    { label: "Meal Name", key: "meals_6_name" },
    { label: "Meal Day 4", key: "meals_7_date" },
    { label: "Meal Name", key: "meals_7_name" },
    { label: "Meal Name", key: "meals_8_name" },
    { label: "Pickup Airline", key: "airportPickupInfo_airlineName" },
    { label: "Pickup Flight Number", key: "airportPickupInfo_flightNumber" },
    { label: "Pickup DateTime", key: "airportPickupInfo_arrivalDateTime" },
    { label: "Pickup Airport", key: "airportPickupInfo_arrivalAirportName" },
    { label: "Pickup Additional Info", key: "airportPickupInfo_additionalInfo" },
    { label: "Dropoff Airline", key: "airportDropoffInfo_airlineName" },
    { label: "Dropoff Flight Number", key: "airportDropoffInfo_flightNumber" },
    { label: "Dropoff DateTime", key: "airportDropoffInfo_departureDateTime" },
    { label: "Dropoff Airport", key: "airportDropoffInfo_departureAirportName" },
    { label: "Dropoff Additional Info", key: "airportDropoffInfo_additionalInfo" },
    { label: "Checked In", key: "checkedInTimestamp" },
    { label: "Checked Out", key: "checkedOutTimestamp" },
    { label: "Registration Time", key: "registerTimestamp" },
    { label: "Status", key: "registrationStatus" }
  ];

  constructor(props) {
    super(props);

    this.state = {
      users: [],
    };
  }

  sortArrayOfDayMealArrays(a, b) {
    let aTime = new Date(a[0]).getTime();
    let bTime = new Date(b[0]).getTime();

    if (aTime === bTime) {
      if ((a[1].trim() === "Breakfast" && b[1].trim() === "Lunch")
        || (a[1].trim() === "Breakfast" && b[1].trim() === "Dinner")
        || (a[1].trim() === "Lunch" && b[1].trim() === "Dinner")) {
        return -1; // a before b
      } else if ((a[1].trim() === "Dinner")
        || (a[1].trim() === "Lunch" && b[1].trim() === "Breakfast")) {
        return 1; // a after b
      } else {
        return 0;
      }
    } else {
      return aTime - bTime;
    }
  }

  sortLodgingAndMealsByDateMeal(users) {
    const refDataLodgings = this.props.lodgings;
    const refDataMeals = this.props.meals;

    //
    // Reference Data - lodging, Meals
    //
    let tempLodgings = [];
    refDataLodgings.forEach(logding => {
      logding.date = logding.date.split("T")[0];
      tempLodgings = [...tempLodgings, { ...logding }];
    });

    let tempRefLodgingObj = {};
    let i = 0;
    tempLodgings.forEach(lodging => {
      let fieldDateName = `lodging_${i}_date`;
      let fieldNameName = `lodging_${i++}_name`;
      tempRefLodgingObj[fieldDateName] = lodging.date;
      tempRefLodgingObj[fieldNameName] = lodging.name;
    });

    let tempMeals = [];
    refDataMeals.forEach(meal => {
      meal.date = meal.date.split("T")[0];
      tempMeals = [...tempMeals, { ...meal }];
    });
    let tempRefMealObj = {};
    let j = 0;
    tempMeals.forEach(meal => {
      let fieldDateName = `meals_${j}_date`;
      let fieldNameName = `meals_${j++}_name`;
      tempRefMealObj[fieldDateName] = meal.date;
      tempRefMealObj[fieldNameName] = meal.name;
    });

    // Convert tempRefmealObj into array to sort the array
    let refMeals = [];
    let x = 0;
    Object.entries(tempRefMealObj).forEach(([key, value]) => {
      if (key.split("_")[0] === "meals" && key.split("_")[2] !== "name") {
        let fieldDate = `meals_${x}_date`
        let fieldName = `meals_${x++}_name`;
        if (!refMeals.includes([fieldDate, fieldName])) {
          refMeals.push([tempRefMealObj[fieldDate], tempRefMealObj[fieldName]]);
        };
      }
    });
    // Sort the array of two-element arrays [ [date1, meal1], [date2, meal2], [date3, meal3] ... ]
    const refMealsSorted = refMeals
      .sort((a, b) => {
        let aTime = new Date(a[0]).getTime();
        let bTime = new Date(b[0]).getTime();

        if (aTime === bTime) {
          if ((a[1].trim() === "Breakfast" && b[1].trim() === "Lunch")
            || (a[1].trim() === "Breakfast" && b[1].trim() === "Dinner")
            || (a[1].trim() === "Lunch" && b[1].trim() === "Dinner")) {
            return -1; // a before b
          } else if ((a[1].trim() === "Dinner")
            || (a[1].trim() === "Lunch" && b[1].trim() === "Breakfast")) {
            return 1; // a after b
          } else {
            return 0;
          }
        } else {
          return aTime - bTime;
        }
      });
    // Convert the sorted array of arrays into an object
    let refMealsObj = {};
    let y = 0;
    refMealsSorted.forEach(meal => {
      let fieldDateName = `meals_${y}_date`;
      let fieldNameName = `meals_${y++}_name`;
      refMealsObj[fieldDateName] = meal[0];
      refMealsObj[fieldNameName] = meal[1];
    });

    //
    // Users - process each user object
    //
    const usersByLodgingMeals = users.map(user => {
      let tempUser = { ...user };
      let tempObj = {};

      // Create a temp user object without lodging and meal information
      Object.entries(tempUser).forEach(([key, value]) => {
        if (key.substring(0, 7) !== "lodging" && key.substring(0, 5) !== "meals") {
          let obj = {};
          obj[key] = value;
          tempObj = { ...tempObj, ...obj };
        }
      });

      // Create dynamically an array of arrays for lodging for sorting
      let userLodgings = [];
      let i2 = 0;
      Object.entries(tempUser).forEach(([key, value]) => {
        if (key.split("_")[0] === "lodging" && key.split("_")[2] !== "name") {
          let fieldDate = `lodging_${i2}_date`
          let fieldName = `lodging_${i2++}_name`;
          if (!userLodgings.includes([fieldDate, fieldName])) {
            userLodgings.push([tempUser[fieldDate], tempUser[fieldName]]);
          };
        }
      });
      // Sort array of arrays
      let userLodgingsSorted = userLodgings.sort((a, b) => {
        return new Date(a[0]) - new Date(b[0]);
      });

      // Dynamically create a user's lodging object with properties according to the sorted array elements
      let userLodgingsObj = {};
      let i = 0;
      // tempLodgingSorted.forEach(lodging => {
      userLodgingsSorted.forEach(lodging => {
        let fieldDateName = `lodging_${i}_date`;
        let fieldNameName = `lodging_${i++}_name`;
        lodging[0] ? (userLodgingsObj[fieldDateName] = lodging[0].split("T")[0]) : (userLodgingsObj[fieldDateName] = lodging[0]);
        userLodgingsObj[fieldNameName] = lodging[1];
      });

      // Create a template object with the ref data lodging object with all the fields and initialize them with empty string
      let userLodgingsTemplate = {};
      Object.entries(tempRefLodgingObj).forEach(([key, value]) => {
        userLodgingsTemplate[key] = value;
        if (key.split("_")[2] === "name") {
          userLodgingsTemplate[key] = "";
        };
      });
      // Upudate the field in the template object with the value in the corresponding user's lodging field
      Object.entries(userLodgingsObj).forEach(([key1, value1]) => {
        if (key1.split("_")[2] === "date") {
          Object.entries(userLodgingsTemplate).forEach(([key, value]) => {
            if (userLodgingsObj[key1] === userLodgingsTemplate[key]) {
              let name1 = `${key1.split("_")[0]}_${key1.split("_")[1]}_name`;
              let name = `${key.split("_")[0]}_${key.split("_")[1]}_name`;
              userLodgingsTemplate[name] = userLodgingsObj[name1];
            }
          })
        }

      });

      let userMeals = [];
      let i3 = 0;
      Object.entries(tempUser).forEach(([key, value]) => {
        if (key.split("_")[0] === "meals" && key.split("_")[2] !== "name") {
          let fieldDate = `meals_${i3}_date`
          let fieldName = `meals_${i3++}_name`;
          if (!userMeals.includes([fieldDate, fieldName])) {
            userMeals.push([tempUser[fieldDate], tempUser[fieldName]]);
          };
        }
      });
      // Soring an array of the two-element[a,b] arrays
      let tempMealsSorted = userMeals
        .sort((a, b) => {
          let aTime = new Date(a[0]).getTime();
          let bTime = new Date(b[0]).getTime();

          if (aTime === bTime) {
            if ((a[1].trim() === "Breakfast" && b[1].trim() === "Lunch")
              || (a[1].trim() === "Breakfast" && b[1].trim() === "Dinner")
              || (a[1].trim() === "Lunch" && b[1].trim() === "Dinner")) {
              return -1; // a before b
            } else if ((a[1].trim() === "Dinner")
              || (a[1].trim() === "Lunch" && b[1].trim() === "Breakfast")) {
              return 1; // a after b
            } else {
              return 0;
            }
          } else {
            return aTime - bTime;
          }
        });
      // Date part only, removing hours.minutes.seconds
      let tempMealsSorted2 = [];
      tempMealsSorted.forEach(meal => {
        let tempDate = "";
        if (meal[0]) {
          tempDate = meal[0].split("T")[0];
        };
        tempMealsSorted2.push([tempDate, meal[1]]);
      });

      // Create meal object with properties according to the sorted array elements
      let tempMealsObj = {};
      let k = 0;
      tempMealsSorted2.forEach(meal => {
        let fieldDateName = `meals_${k}_date`;
        let fieldNameName = `meals_${k++}_name`;
        tempMealsObj[fieldDateName] = meal[0];
        tempMealsObj[fieldNameName] = meal[1];
      });
      // Create a template object with the ref data meals object with all the fields
      let userMealsTemplate = {};
      Object.entries(refMealsObj).forEach(([key, value]) => {
        userMealsTemplate[key] = value;
      });
      // Update the field in the template object with the value in the corresponding user's lodging field
      Object.entries(userMealsTemplate).forEach(([key, value]) => {
        if (key.split("_")[2] === "date") {
          Object.entries(tempMealsObj).forEach(([dateKey, dateValue]) => {
            if (tempMealsObj[dateKey] === userMealsTemplate[key]) {
              let dateName = `${dateKey.split("_")[0]}_${dateKey.split("_")[1]}_name`;
              let name = `${key.split("_")[0]}_${key.split("_")[1]}_name`;
              if (tempMealsObj[dateName] === userMealsTemplate[name]) {
                // Append the checked mark for matches
                userMealsTemplate[name] = tempMealsObj[dateName] + "-X";
                delete tempMealsObj[dateName];
                delete tempMealsObj[dateKey];
              }
            }
          })
        }
      });
      // 2nd path to set the unmatched entries to empty string and remove the checked mark suffix from the matched entries
      Object.entries(userMealsTemplate).forEach(([key, value]) => {
        if (key.split("_")[2] === "name") {
          let length = userMealsTemplate[key].length;
          if (userMealsTemplate[key].substring(length - 2, length) === "-X") {
            userMealsTemplate[key] = userMealsTemplate[key].substring(0, length - 2);
          } else {
            userMealsTemplate[key] = "";
          }
        }
      });
      let sortedTempUsers = { ...tempObj, ...userLodgingsTemplate, ...userMealsTemplate };

      return sortedTempUsers;

    });
    return usersByLodgingMeals;
  }

  getFilterUsers = () => {
    const populatedUsers = this.props.filteredUsers?.map((user) => {
      return this.constructor.convertToSingleDepth(user);
      // return this.constructor.stringifyObjectFields(user);
    });
    // jyh
    const sortedPopulatedUsers = this.sortLodgingAndMealsByDateMeal(populatedUsers);
    this.setState({ users: sortedPopulatedUsers }, () => {
      // click the CSVLink component to trigger the CSV download
      this.csvLink.current.link.click();
    });
  }

  fetchAttendingUsers = () => {
    api.get("/api/users/csvAttending").then((res) => {
      const populatedUsers = res.data.map((user) => {
        return this.constructor.convertToSingleDepth(user);
        // return this.constructor.stringifyObjectFields(user);
      });
      // jyh
      const sortedPopulatedUsers = this.sortLodgingAndMealsByDateMeal(populatedUsers);
      this.setState({ users: sortedPopulatedUsers }, () => {
        // click the CSVLink component to trigger the CSV download
        this.csvLink.current.link.click();
      });
    });
  };

  fetchAllUsers = () => {
    api.get("/api/users/csv").then((res) => {
      const populatedUsers = res.data.map((user) => {
        return this.constructor.convertToSingleDepth(user);
        // return this.constructor.stringifyObjectFields(user);
      });
      // jyh
      const sortedPopulatedUsers = this.sortLodgingAndMealsByDateMeal(populatedUsers);
      this.setState({ users: sortedPopulatedUsers }, () => {
        // click the CSVLink component to trigger the CSV download
        this.csvLink.current.link.click();
      });
    });
  };

  render() {
    const { users } = this.state;

    return (
      <>
        <Button
          type="button"
          colorScheme={this.props.attendingUsers ? "blue" : "green"}
          marginTop={2}
          marginLeft={3}
          marginBottom={6}
          marginRight={3}
          onClick={
            this.props.filteredUsers
              ? this.getFilterUsers
              : (this.props.attendingUsers ? this.fetchAttendingUsers : this.fetchAllUsers)
          }
          isDisabled={!hasPermission(this.props.user, ["download", "download_for_church"])}
        >
          {(this.props.language === "en" ? "Export " : "下載")}
          {this.props.filteredUsers
            ? (this.props.language === "en" ? "This Page" : "此頁上的") : (this.props.attendingUsers
              ? (this.props.language === "en" ? "Attending and Accepted" : "報名被接受的") : (this.props.language === "en" ? "All" : "所有的"))}{" "}
          {(this.props.language === "en" ? "Users to CSV" : "使用者文件")}
        </Button>
        <CSVLink
          data={users}
          headers={this.csvHeaders}
          ref={this.csvLink}
          style={{ display: "none" }}
          filename="registration_user_data.csv"
          target="_blank"
        />
      </>
    );
  }
}
